export default __webpack_public_path__ + "static/media/Prison-3D-Model-00.3b64a54a.jpg";